// extracted by mini-css-extract-plugin
export var carrierIcon = "_u5-0";
export var carrierLogo = "_u5-1";
export var detailsSection = "_u5-2";